import { Injectable } from '@angular/core';
import {
  Router,
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot
} from '@angular/router';
import { Observable } from 'rxjs/Observable';

import { AuthenticationService } from '../../_shared/services/authentication.service';

@Injectable()
export class AuthGuard implements CanActivate {
  constructor(
    private router: Router,
    private authenticationService: AuthenticationService
  ) { }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    // guard to protect routes from user that hasn't logged in
    return this.authenticationService.isAuthenticated().then(loginState => {
      console.log('authguard', 'Guard', loginState);
      // if not logged in, redirect to login page
      if (!loginState) {
        this.router.navigate(['/']);
      }
      return loginState;
    });
  }
}



// WEBPACK FOOTER //
// D:/Work-Local/frontend/src/app/_shared/guards/auth.guard.ts